/* tslint:disable */
/* eslint-disable */
/**
 * Assemblean Production Solutions
 * Produce the lean way with APCS
 *
 * The version of the OpenAPI document: 0.9.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * A simplified version of the ArticleSerializer that is tailored to provide
 * all information that are important for a GuestRequest part.
 * 
 * Note:
 *     This serializer is meant to be used as a read-only serializer. To deserialize
 *     an incoming Part POST-request, use the PartCreationSerializer.
 * @export
 * @interface APIPatchedPartRequest
 */
export interface APIPatchedPartRequest {
    /**
     * 
     * @type {string}
     * @memberof APIPatchedPartRequest
     */
    name?: string;
    /**
     * 
     * @type {string}
     * @memberof APIPatchedPartRequest
     */
    number?: string;
    /**
     * 
     * @type {string}
     * @memberof APIPatchedPartRequest
     */
    hoopsPartId?: string;
    /**
     * 
     * @type {string}
     * @memberof APIPatchedPartRequest
     */
    qualityClass?: string;
    /**
     * 
     * @type {boolean}
     * @memberof APIPatchedPartRequest
     */
    isBomBase?: boolean;
}

/**
 * Check if a given object implements the APIPatchedPartRequest interface.
 */
export function instanceOfAPIPatchedPartRequest(value: object): value is APIPatchedPartRequest {
    return true;
}

export function APIPatchedPartRequestFromJSON(json: any): APIPatchedPartRequest {
    return APIPatchedPartRequestFromJSONTyped(json, false);
}

export function APIPatchedPartRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): APIPatchedPartRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'name': json['name'] == null ? undefined : json['name'],
        'number': json['number'] == null ? undefined : json['number'],
        'hoopsPartId': json['hoops_part_id'] == null ? undefined : json['hoops_part_id'],
        'qualityClass': json['quality_class'] == null ? undefined : json['quality_class'],
        'isBomBase': json['is_bom_base'] == null ? undefined : json['is_bom_base'],
    };
}

export function APIPatchedPartRequestToJSON(value?: APIPatchedPartRequest | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'name': value['name'],
        'number': value['number'],
        'hoops_part_id': value['hoopsPartId'],
        'quality_class': value['qualityClass'],
        'is_bom_base': value['isBomBase'],
    };
}

